import '../../../../../assets/css/components/customer/dashboard/appnavbar/AppNavbar.css';
import logoImg from '../../../../../assets/images/logoo.jpg';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import echo from '../../../../../config/echo';
import AppContext from "../../../../../context/AppContext";
import {
  Home, Wrench, Briefcase, Inbox,
  Search, Bell, User, MapPin, Plus,
  LayoutGrid, X, Crown
} from 'lucide-react';
import axios from "axios";

const DESK_LINKS = [
  { label: 'Home',       path: '/customer-dashboard' },
  { label: 'Categories',   path: '/customer-category'  },
  { label: 'All Jobs', path: '/my-jobs'         },
  { label: 'Help & Support',      path: '/customer-support'     },
    // { label: 'Inbox',      path: '/customer-inbox'     },
];

const AppNavbar = () => {
   console.log("AppNavbar Mounted");
  const {authToken, setAuthToken, baseUrl} = useContext(AppContext);
  const navigate       = useNavigate();
  const location       = useLocation();
  const [notificationCount, setNotificationCount] = useState(0);
  const [scrolled,     setScrolled]   = useState(false);
  const [searchOpen,   setSearchOpen] = useState(false);
  const [searchQuery,  setSearchQuery]= useState('');
  const inputRef = useRef(null);
  const receivedNotifications = useRef(new Set());
  const [currentLocation, setCurrentLocation] = useState("Your Location");



  const isHomePage = location.pathname === '/customer-dashboard';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);


  // notifications count api
useEffect(() => {

  const getNotificationCount = () => {

    axios.get(`${baseUrl}/customer/notification/count`, {
      headers:{
        Authorization:`Bearer ${localStorage.getItem("authToken")}`
      }
    })
    .then((response)=>{

      setNotificationCount(response.data.count);

    })
    .catch((error)=>{
      console.log(error);
    });

  };


  getNotificationCount();

}, [baseUrl]);

  useEffect(() => {

  if (!navigator.geolocation) {
    setCurrentLocation("Location unavailable");
    return;
  }


  navigator.geolocation.getCurrentPosition(
    async (position) => {

      const lat = position.coords.latitude;
      const lng = position.coords.longitude;


      try {

        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
        );


        const data = await response.json();


        const city =
          data.address.city ||
          data.address.town ||
          data.address.village ||
          "";


        const country = data.address.country || "";


        setCurrentLocation(`${city}, ${country}`);


      } catch(error) {

        console.log(error);
        setCurrentLocation("Location unavailable");

      }

    },

    (error)=>{
      console.log(error);
      setCurrentLocation("Allow Location");
    }

  );

}, []);

useEffect(() => {

    const customer = JSON.parse(localStorage.getItem("customer"));

    if (!customer?.id) return;

    const channelName = `customer-${customer.id}`;

    console.log("Joining:", channelName);

    const channel = echo.channel(channelName);


    channel.listen(".NotificationUpdates", (event)=>{

        console.log("Customer Socket Received:", event);

        const id = event.notification.id;

        if(receivedNotifications.current.has(id)){
            console.log("Duplicate notification ignored:", id);
            return;
        }

        receivedNotifications.current.add(id);

        setNotificationCount(prev => prev + 1);

    });


  

    return () => {

        console.log("Leaving:", channelName);

        echo.leave(channelName);

    };


}, []);


  useEffect(() => {
    if (searchOpen) setTimeout(() => inputRef.current?.focus(), 50);
  }, [searchOpen]);

  useEffect(() => {
  console.log("Customer Token:", authToken);
}, [authToken]);

  const openSearch  = () => setSearchOpen(true);
  const closeSearch = () => { setSearchOpen(false); setSearchQuery(''); };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/appservices?q=${encodeURIComponent(searchQuery.trim())}`);
      closeSearch();
    }
  };

  const isActive = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <>
      {/* ══════════ DESKTOP NAVBAR ══════════ */}
      <nav className={'nb-desk' + (scrolled ? ' nb-desk--scrolled' : '')}>
        <div className="nb-desk__inner">

          {/* Logo — image with transparent bg */}
          <div className="nb-desk__logo" onClick={() => navigate('/')}>
            <img src={logoImg} alt="WorkHub" className="nb-desk__logo-img" />
          </div>

          {/* Links */}
          {!searchOpen && (
            <div className="nb-desk__links">
              {DESK_LINKS.map(l => (
                <button
                  key={l.path}
                  className={'nb-desk__link' + (isActive(l.path) ? ' nb-desk__link--active' : '')}
                  onClick={() => navigate(l.path)}
                >
                  {l.label}
                </button>
              ))}
            </div>
          )}

          {/* Desktop search bar */}
          {searchOpen && (
            <form className="nb-desk__searchbar" onSubmit={handleSearchSubmit}>
              <Search size={17} className="nb-desk__searchbar-icon"/>
              <input
                ref={inputRef}
                type="text"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Search services..."
                className="nb-desk__searchbar-input"
              />
              <button type="button" className="nb-desk__searchbar-close" onClick={closeSearch}>
                <X size={17}/>
              </button>
            </form>
          )}

          {/* Right icons */}
          <div className="nb-desk__icons">
            <button className="nb-desk__icon-btn nb-desk__icon-btn--bell" title="Notifications" onClick={() => navigate('/customer-notifications')}>
              <Bell size={20}/>
             {
 notificationCount > 0 &&
<span className="nb-mob-top__notif-count">
 {notificationCount}
</span>
}
            </button>
            <button className="nb-desk__icon-btn nb-desk__icon-btn--profile" title="Profile" onClick={() => navigate('/customer-profile')}>
              <User size={20}/>
            </button>
          </div>

        </div>
      </nav>

      {/* ══════════ MOBILE TOP BAR ══════════ */}
      {isHomePage && (
        <div className="nb-mob-top">
          <div className="nb-mob-top__location" onClick={() => navigate('/')}>
            <MapPin size={16} className="nb-mob-top__location-icon"/>
            <div>
              <span className="nb-mob-top__location-label">My Location</span>
<span className="nb-mob-top__location-city">
  {currentLocation}
</span>            </div>
          </div>
          <div className="nb-mob-top__icons">
            <button className="nb-mob-top__icon-btn nb-mob-top__icon-btn--bell" onClick={() => navigate('/customer-notifications')}>
              <Bell size={20}/>
             {
 notificationCount > 0 &&
 <span className="nb-desk__notif-count">
   {notificationCount}
 </span>
}
            </button>
            <button className="nb-mob-top__icon-btn nb-mob-top__profile-hidden" onClick={() => navigate('/customer-profile')}>
              <User size={20}/>
            </button>
          </div>
        </div>
      )}

      {/* ══════════ MOBILE SEARCH OVERLAY ══════════ */}
      {searchOpen && (
        <div className="nb-mob-search-overlay" onClick={closeSearch}>
          <div className="nb-mob-search-box" onClick={e => e.stopPropagation()}>
            <form className="nb-mob-search-form" onSubmit={handleSearchSubmit}>
              <Search size={17} className="nb-mob-search-icon"/>
              <input
                ref={inputRef}
                type="text"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Search services..."
                className="nb-mob-search-input"
              />
              <button type="button" className="nb-mob-search-close" onClick={closeSearch}>
                <X size={18}/>
              </button>
            </form>
          </div>
        </div>
      )}

    {/* ══════════ MOBILE BOTTOM NAV ══════════ */}
<nav className="nb-mob-bottom">
  <button
    className={'nb-mob-bottom__item' + (isActive('/customer-dashboard') ? ' nb-mob-bottom__item--active' : '')}
    onClick={() => navigate('/customer-dashboard')}
  >
    <Home size={22}/><span>Home</span>
  </button>

  <button
    className={'nb-mob-bottom__item' + (isActive('/customer-category') ? ' nb-mob-bottom__item--active' : '')}
    onClick={() => navigate('/customer-category')}
  >
    <LayoutGrid size={22}/><span>Category</span>
  </button>

  <button className="nb-mob-bottom__post" onClick={() => navigate('/post-a-job')}>
    <div className="nb-mob-bottom__post-circle">
      <Plus size={26} strokeWidth={2.5}/>
    </div>
    <span>Post</span>
  </button>


 {/* Jobs */}
<button
  className={'nb-mob-bottom__item' + (isActive('/my-jobs') ? ' nb-mob-bottom__item--active' : '')}
  onClick={() => navigate('/my-jobs')}
>
  <Briefcase size={22}/><span>Jobs</span>
</button>

  <button
    className={'nb-mob-bottom__item' + (isActive('/customer-profile') ? ' nb-mob-bottom__item--active' : '')}
    onClick={() => navigate('/customer-profile')}
  >
    <User size={22}/><span>Profile</span>
  </button>
</nav>
    </>
  );
};

export default AppNavbar;